import styles from './Sparkline.module.css'

interface SparklineProps {
  values: readonly number[]
  color?: string
  className?: string
  /** 접근성용 요약 (예: 최근 7일 추이) */
  label?: string
}

/**
 * 카드용 미니 꺾은선. 차트 라이브러리 없이 SVG로 그림.
 * Phase 1-A: 목 데이터 / Phase 1-B: daily API points 연결 예정.
 */
export default function Sparkline({
  values,
  color = '#6B73FF',
  className,
  label = '최근 추이'
}: SparklineProps) {
  const width = 120
  const height = 36
  const padY = 3

  if (values.length === 0) {
    return (
      <div className={`${styles.wrap} ${className ?? ''}`} aria-hidden>
        <svg viewBox={`0 0 ${width} ${height}`} className={styles.svg} preserveAspectRatio="none">
          <line
            x1={0}
            y1={height / 2}
            x2={width}
            y2={height / 2}
            stroke={color}
            strokeWidth={1.5}
            strokeOpacity={0.35}
          />
        </svg>
      </div>
    )
  }

  const max = Math.max(...values, 1)
  const min = Math.min(...values, 0)
  const range = Math.max(max - min, 1)
  const stepX = values.length === 1 ? 0 : width / (values.length - 1)

  const points = values.map((v, i) => {
    const x = values.length === 1 ? width / 2 : i * stepX
    const y = height - padY - ((v - min) / range) * (height - padY * 2)
    return { x, y, v }
  })

  const polyline = points.map((p) => `${p.x},${p.y}`).join(' ')
  const last = points[points.length - 1]

  return (
    <div className={`${styles.wrap} ${className ?? ''}`} role="img" aria-label={label}>
      <svg viewBox={`0 0 ${width} ${height}`} className={styles.svg} preserveAspectRatio="none">
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          points={polyline}
        />
        <circle cx={last.x} cy={last.y} r={2.75} fill={color} />
      </svg>
    </div>
  )
}
